var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brb-input" },
    [
      _c("validation-provider", {
        attrs: {
          vid: _vm.vid,
          rules: _vm.computedValidation,
          name: _vm.errorName || _vm.label,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ errors, classes }) {
              return [
                _c(
                  _vm.component,
                  _vm._g(
                    _vm._b(
                      {
                        ref: "brb-input",
                        tag: "component",
                        class: [_vm.attrs.class, classes, { empty: _vm.empty }],
                        model: {
                          value: _vm.model,
                          callback: function ($$v) {
                            _vm.model = $$v
                          },
                          expression: "model",
                        },
                      },
                      "component",
                      _vm.attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                ),
                _vm.label
                  ? _c("span", { staticClass: "label font-weight-bold mb-0" }, [
                      _vm._v(" " + _vm._s(_vm.label) + " "),
                      _vm.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" * "),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.append
                  ? _c("span", { class: ["append mb-0 pr-3 border-right"] }, [
                      _vm._v(" " + _vm._s(_vm.append) + " "),
                    ])
                  : _vm._e(),
                _vm.unit || _vm.currency
                  ? _c("span", { staticClass: "unit mb-0" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.unit ||
                              _vm.$t(`currency.${_vm.$config.currency.display}`)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                errors && errors.length
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "d-block text-right text-danger small mt-2",
                      },
                      [_vm._v(" " + _vm._s(errors[0]) + " ")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }